import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import {
  UserGroupRulesInputs,
  transformUserGroupData,
  userGroupCreateDefaultValues,
} from './userGroupRules';

export const UserGroupCreate = () => (
  <MoonstarCreate redirect="list" transform={transformUserGroupData}>
    <MoonstarCreateForm defaultValues={userGroupCreateDefaultValues}>
      <SimpleStack>
        <TextInput source="name" validate={required()} />
        <UserGroupRulesInputs />
      </SimpleStack>
    </MoonstarCreateForm>
  </MoonstarCreate>
);
